import React, { useState, useEffect } from 'react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Table from '../../components/ui/Table';
import api from '../../services/api';

export default function DisplayReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const res = await api.get('/v1/display/reports?page=1&per_page=100');
        if (res?.data) setReports(res.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    }
    load();
  }, []);

  const columns = [
    { key: 'created_at', label: 'Дата', render: v => <span style={{ color: '#94A3B8', fontSize: 12 }}>{v ? new Date(v).toLocaleString('ru-RU') : '\u2014'}</span> },
    { key: 'employee_name', label: 'Сотрудник', render: v => <span style={{ fontWeight: 500 }}>{v || '\u2014'}</span> },
    { key: 'store_name', label: 'Магазин', render: v => v || '\u2014' },
    { key: 'product_name', label: 'Товар', render: v => <span style={{ fontWeight: 600 }}>{v || '\u2014'}</span> },
    { key: 'status', label: 'Статус', render: v => <Badge variant={v === 'with_photo' ? 'success' : 'warning'} dot>{v === 'with_photo' ? 'С фото' : 'Без фото'}</Badge> },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.02em' }}>Отчёты по выкладке</h1>
      <Card padding="0">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 48, color: '#94A3B8' }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', border: '3px solid rgba(0,206,238,0.15)', borderTopColor: '#00CEEE', animation: 'spin 0.8s linear infinite', margin: '0 auto 10px' }} />
            Загрузка...
          </div>
        ) : (
          <Table columns={columns} data={reports} emptyText="Нет отчётов по выкладке" />
        )}
      </Card>
    </div>
  );
}
